'use client'

import type { Data } from '@repo/strapi-types'
import {
	Carousel,
	CarouselControls,
	CarouselItem,
	CarouselItemNav,
	CarouselItems,
	CarouselNextButton,
	CarouselPreviousButton,
} from '@/components/elementary/carousel/Carousel'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import Heading from '@/components/typography/Heading'
import { Paragraph } from '@/components/typography/Paragraph'

export function FeatureCardsMobileCarousel({
	cards,
}: {
	readonly cards: readonly Data.Component<'shared.icon-card'>[]
}) {
	return (
		<div className="lg:hidden pb-14">
			<Carousel className="relative">
				<CarouselItems>
					{cards.map((card) => (
						<CarouselItem key={card.id}>
							<div className="bg-white border border-wolf-gray-300 rounded-sm p-4 flex flex-col gap-3 overflow-hidden h-full w-full">
								{card.icon && (
									<BasicImage
										component={card.icon}
										className="h-15 w-auto self-start object-contain"
										ignoreMediaSize
									/>
								)}
								<Heading tag="h3" fontSize="headingMediumMedium">
									{card.title}
								</Heading>
								<Paragraph fontSize="bodyRegularLarge">{card.description}</Paragraph>
							</div>
						</CarouselItem>
					))}
				</CarouselItems>

				<CarouselControls className="absolute w-full justify-between -bottom-12 py-2 px-4 gap-7">
					<CarouselPreviousButton className="shadow-none bg-transparent p-0" />
					<CarouselItemNav activeColor="neutral-light-600" />
					<CarouselNextButton className="shadow-none bg-transparent p-0" />
				</CarouselControls>
			</Carousel>
		</div>
	)
}
